<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>User Groups</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
            id="search"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New User Group
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <div class="row">
          <div class="col">
            <v-text-field
              v-model="selectedObj.Name"
              label="Group Name*"
              required
              id="name"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="selectedObj.Description"
              label="Group Description"
              id="description"
            ></v-text-field>
          </div>
        </div>
        <!-- 
        <div class="row">
          <div class="col">
            <v-combobox
              v-model="selectedObj.users"
              :items="users"
              :search-input.sync="searchUser"
              :menu-props="{ closeOnClick: false, disableKeys: true }"
              item-text="firstName"
              item-value="id"
              hide-selected
              hide-no-data
              dense
              label="Add users to the group"
              multiple
              persistent-hint
              chips
              return-object
              deletable-chips
              @change="onChangeUsers"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </div>
        </div>
        -->

        <div class="row">
          <div class="col">
            <v-card>
              <div class="row">
                <div class="col-5 ml-5">
                  <v-text-field
                    v-model="SearchUser"
                    label="Search"
                    id="searchUSer"
                  ></v-text-field>
                </div>
                <div class="col-6"></div>
              </div>
              <v-divider></v-divider>
              <div style="height: 350px; overflow-y: scroll">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <th class="text-left" style="width: 50px"></th>
                      <th class="text-left">User</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in resultQuery" :key="item.id">
                        <td>
                          <v-checkbox
                            class="pt-1"
                            :id="'svg' + item.id"
                            v-model="item.IsSelected"
                          ></v-checkbox>
                        </td>
                        <td>{{ item.firstName }} {{ item.lastName }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="float-right">
              <v-btn @click="onCancel()"> Cancel </v-btn>
              <v-btn
                class="mr-4"
                color="primary"
                @click="onSave()"
                :loading="loading"
                :disabled="loading"
              >
                Save
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Description</th>
                  <th class="text-left">Organization</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + item.id">
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Description }}</td>
                  <td>{{ item.UserUserGroup[0].organization == null ? "" : item.UserUserGroup[0].organization.Name }}</td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import * as api from "@/api";

export default {
  name: "UserGroup",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  created() {
    this.getUsers();
    this.getUserGroupByPagin();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    resultQuery() {
      if (this.SearchUser) {
        return this.users.filter((item) => {
          return this.SearchUser.toLowerCase()
            .split(" ")
            .every((v) => item.firstName.toLowerCase().includes(v) || 
                          item.lastName.toLowerCase().includes(v));
        });
      } else {
        return this.users;
      }
    },
  },
  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getUserGroupByPagin();
    },
    onNew() {
      //this.getUsers();
      this.isEdit = true;
      this.selectedObj.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Description = "";
      this.selectedObj.users = [];
      this.notify.type = 0;
    },
    onSave() {
      console.log(this.selectedObj);
      this.notify.type = 0;
      this.notify.errors = [];

      var objs = this.users.filter((obj) => {
        return obj.IsSelected === true;
      });
      console.log(objs);

      for (let i = 0; i < objs.length; i++) {
        this.selectedObj.users.push(objs[i]);
      }

      if (this.selectedObj.Name == "") {
        this.notify.type = 4;
        this.notify.errors.push("Please enter group name.");
        return;
      }
      if (this.selectedObj.users.length == 0) {
        this.notify.type = 4;
        this.notify.errors.push("Please add users.");
        return;
      }

      this.loading = true;
      new Promise((resolve, reject) => {
        api
          .update("user-group", this.selectedObj)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              this.loading = false;
              this.isEdit = false;
              this.getUserGroupByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              this.loading = false;
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            this.loading = false;
            reject(error);
          });
      });
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
      this.getUserUserGroups(obj.id);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("user-group", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getUserGroupByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
      this.notify.type = 0;
      this.notify.errors = [];
    },
    getUsers() {
      this.users = [];
      new Promise((resolve, reject) => {
        api
          .getAll("user")
          .then((response) => {
            resolve(response);
            console.log(response);
            this.users = response.data;

            for (let i = 0; i < this.users.length; i++) {
              this.users[i].IsSelected = false;
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getUserGroups() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("user-group")
          .then((response) => {
            resolve(response);
            this.list = response.data;
            console.log(this.list);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getUserGroupByPagin();
    },
    getUserGroupByPagin() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("user-group", this.paging)
          .then((response) => {
            resolve(response);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            console.log(this.list);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getUserUserGroups(id) {
      this.selectedObj.users = [];
      for (let i = 0; i < this.users.length; i++) {
        this.users[i].IsSelected = false;
      }
      new Promise((resolve, reject) => {
        api
          .getByID("user-user-group/users", id)
          .then((response) => {
            resolve(response);

            /*for (let i = 0; i < response.data.length; i++) {
              this.selectedObj.users.push(response.data[i]);
            }*/
            for (let i = 0; i < response.data.length; i++) {
              var objIndex = this.users.findIndex(
                (p) => p.id == response.data[i].id
              );
              this.users[objIndex].IsSelected = true;
            }
            this.SearchUser = " ";
            this.SearchUser = "";
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onChangeUsers(items) {
      for (let i = 0; i < items.length; i++) {
        if (!(typeof this.selectedObj.users[i] === "object")) {
          items.splice(i, 1);
          break;
        }
      }
    },
  },
  data() {
    return {
      list: [],
      users: [],
      isEdit: false,
      isNew: false,
      Search: "",
      SearchUser: "",
      // searchUser: null,
      selectedObj: {},
      selectedUsers: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
    };
  },
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/UserGroup.vue